import ajv from '../ajv';
import getComponentName from '../getComponentName';
import validateSchema from '../validate/validateSchema';

/**
 * Build the validator for the properties of a component
 * @private
 * @param {*} propertyDefinitions The definitions of properties passed into createCustomElement's config.properties
 * @returns {Function(properties, host)} The function to validate the component's properties
 */
function buildPropertiesValidator(propertyDefinitions) {
	if (process.env.NODE_ENV !== 'production') {
		const baseSchema = {
			type: 'object',
			properties: {},
			required: [],
			dependencies: {}
		};

		for (const propertyName in propertyDefinitions) {
			const {schema, required, dependencies} = propertyDefinitions[propertyName];
			if (schema) baseSchema.properties[propertyName] = schema;
			if (required) baseSchema.required.push(propertyName);
			if (dependencies) baseSchema.dependencies[propertyName] = dependencies;
		}

		let validate;
		try {
			validate = ajv.compile(baseSchema);
		} catch (e) {
			console.error(e); // eslint-disable-line no-console
			return () => false;
		}

		return function validateProperties(properties, host) {
			const component = getComponentName(host);
			return validateSchema(validate, properties, {errorPrefix: `Property for ${component}: `});
		};
	}

	return () => true;
}

export default buildPropertiesValidator;
